import { Grid } from '@chakra-ui/react';
import { ContractSearchResponseDTO } from 'models';
import { DetailItem } from './DetailItem';

interface ViewFormProps {
  contract: ContractSearchResponseDTO;
}

export const ViewCreditorFormReadOnly = ({ contract }: ViewFormProps) => {
  const { credor } = contract;

  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={4}>
      <DetailItem label="Nome" value={credor?.nome} />
      <DetailItem label="CNPJ" value={credor?.cnpj} />
    </Grid>
  );
};